import { TSupportedCredential } from '@commenda/types/src/credential/types';
import { SWRFetcher } from '@commenda/utils';
import { Country } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

export function useSupportedCredentials(params: { country: Country }) {
  const queryString = new URLSearchParams();

  queryString.append('country', params.country);

  const {
    data,
    error,
    mutate,
  }: {
    data?: { supportedCredentials: TSupportedCredential[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `credentials/supportedCredentials?${queryString.toString()}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
